var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4991 52.2667C41.9012 52.2667 52.7658 41.4021 52.7658 28C52.7658 14.5979 41.9012 3.73334 28.4991 3.73334C15.097 3.73334 4.23242 14.5979 4.23242 28C4.23242 41.4021 15.097 52.2667 28.4991 52.2667Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2643 37.1933L41.4253 22.0323C41.6003 21.8572 41.6986 21.6199 41.6986 21.3724C41.6986 21.1249 41.6003 20.8876 41.4253 20.7125L40.1056 19.3928C40.0189 19.3059 39.9159 19.2369 39.8025 19.1899C39.6891 19.1428 39.5676 19.1186 39.4448 19.1186C39.3221 19.1186 39.2005 19.1428 39.0871 19.1899C38.9737 19.2369 38.8707 19.3059 38.784 19.3928L25.6053 32.5715L17.7056 24.6736C17.6189 24.5867 17.5159 24.5177 17.4025 24.4707C17.2891 24.4236 17.1676 24.3994 17.0448 24.3994C16.9221 24.3994 16.8005 24.4236 16.6871 24.4707C16.5737 24.5177 16.4707 24.5867 16.384 24.6736L15.0643 25.9933C14.8893 26.1684 14.791 26.4057 14.791 26.6532C14.791 26.9007 14.8893 27.138 15.0643 27.3131L24.9445 37.1933C25.3141 37.5629 25.8966 37.5629 26.2643 37.1933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.2042ba73f8c514753929428384458137.svg";
export { ForwardRef as ReactComponent };